import { DashboardHeader } from '@/features/dashboard/components/DashboardHeader'
import { TileRenderer } from '@/features/dashboard/components/TileRenderer'
import { SortableBentoGrid } from '@/shared/components/SortableBentoGrid'
import { SortableBentoItem } from '@/shared/components/SortableBentoItem'
import { SavingIndicator } from '@/shared/components/SavingIndicator'
import { useDashboardLayout } from '@/features/dashboard/hooks/useDashboardLayout'

export function Home() {
  const { tiles, isLoading, isSaving, reorderTiles } = useDashboardLayout()

  const visibleTiles = tiles.filter(t => t.visible !== false)

  const handleReorder = (newOrder: string[]) => {
    const reorderedTiles = newOrder.map(id => tiles.find(t => t.id === id)!).filter(Boolean)
    reorderTiles(reorderedTiles)
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-canvas text-foreground flex items-center justify-center">
        <div className="text-white/60">Loading dashboard...</div>
      </div>
    )
  }

  return (
    <div className="h-full overflow-y-auto overscroll-contain p-4 md:p-8 pb-32 md:pb-8">
      <DashboardHeader title="Overview" subtitle="Today's Focus" />

      {/* Layout controls */}
      {!isLoading && (
        <div className="mb-4 flex items-center justify-between">
          <span className="text-xs text-white/40">Drag cards to reorder</span>
          <SavingIndicator isSaving={isSaving} />
        </div>
      )}

      <SortableBentoGrid
        items={visibleTiles.map(t => t.id)}
        onReorder={handleReorder}
      >
        {visibleTiles.map(tile => (
          <SortableBentoItem
            key={tile.id}
            id={tile.id}
            colSpan={tile.colSpan}
            rowSpan={tile.rowSpan}
          >
            <TileRenderer component={tile.component} />
          </SortableBentoItem>
        ))}
      </SortableBentoGrid>
    </div>
  )
}
